import { IndiceModeType } from '../models/enums/indice-mode-type.enum';
import * as i0 from "@angular/core";
var FormatService = /** @class */ (function () {
    function FormatService() {
    }
    FormatService.prototype.formatCursor = function (value, mode) {
        switch (mode) {
            case IndiceModeType.ac:
                return this.localiseNumber(value);
            case IndiceModeType.amount:
                return this.formatAmount(value) + "€";
            default:
                return this.formatPercent(value) + "%";
        }
    };
    FormatService.prototype.formatAmount = function (value, mode, base) {
        if (mode === void 0) { mode = 'rounded'; }
        if (base === void 0) { base = 0.001; }
        if (value == null || isNaN(value)) {
            return "";
        }
        switch (mode) {
            case 'auto':
                return this.formatAuto(value);
            case 'fixed':
                return this.formatFixe(value, base);
            default:
                return this.localiseNumber(Math.round(value));
        }
    };
    FormatService.prototype.formatPercent = function (value, offset) {
        if (offset === void 0) { offset = 0; }
        if (value == null || isNaN(value) || isNaN(offset)) {
            return "";
        }
        return this.localiseNumber(this.precision(((value + offset) * 100), 2));
    };
    FormatService.prototype.precision = function (number, precision) {
        if (number == null || isNaN(number)) {
            return 0;
        }
        var factor = Math.pow(10, precision);
        return Math.round(number * factor) / factor;
    };
    FormatService.prototype.partitionsArrayToTree = function (partitions, parent) {
        var _this = this;
        var treePartitions = partitions.filter(function (p) { return p.parentCode == null; });
        if (!parent) {
            treePartitions.map(function (p) {
                _this.partitionsArrayToTree(partitions, p);
            });
        }
        else {
            var childrenArray = partitions.filter(function (p) { return p.parentCode === parent.partitionDetails.code; });
            if (childrenArray.length > 0) {
                parent['partitions'] = childrenArray;
                childrenArray.forEach(function (child) {
                    _this.partitionsArrayToTree(partitions, child);
                });
            }
        }
        return treePartitions;
    };
    // Calculate the shorten value and add corresponding symbol
    FormatService.prototype.formatAuto = function (value) {
        var currency = '€';
        if (Math.abs(value) < 1000) {
            return this.precision(value, 2) + currency;
        }
        var symbols = ["K", "M", "B"];
        var i = 0;
        while (Math.abs(value) >= 1000 && i < symbols.length) {
            value /= 1000;
            i++;
        }
        return this.formatFixe(value) + " " + symbols[i - 1] + currency;
    };
    // Calculate the value multiply by base with " " between thousands
    FormatService.prototype.formatFixe = function (value, base) {
        if (base === void 0) { base = 1; }
        return this.localiseNumber(this.precision(value * base, 2));
    };
    FormatService.prototype.localiseNumber = function (number) {
        return number.toString().replace(/[.]/, ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        // return number.toLocaleString('de-DE');
    };
    FormatService.ngInjectableDef = i0.defineInjectable({ factory: function FormatService_Factory() { return new FormatService(); }, token: FormatService, providedIn: "root" });
    return FormatService;
}());
export { FormatService };
